import './SMSPhonePreview.scss';
import React from 'react';
import { ReactComponent as PhoneNotch } from 'assets/icons/icon-phone-notch.svg';
import type { TSMSPreviewData } from 'components/FlowBuilder/FlowSidePanels/types';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { ReactComponent as ErrorIcon } from 'assets/icons/icon-error-triangle.svg';

const MAIN_CLASS = `sms-phone-preview`;
const CLASSES = {
  HEADER: `${MAIN_CLASS}__header`,
  CONTENT: `${MAIN_CLASS}__content`,
  SMS: `${MAIN_CLASS}__content__sms`,
  SMS_HEADER: `${MAIN_CLASS}__content__sms__header`,
  SMS_SENDER_NUMBER: `${MAIN_CLASS}__content__sms__header__sender-number`,
  SMS_TIME: `${MAIN_CLASS}__content__sms__header__time`,
  SMS_CONTENT: `${MAIN_CLASS}__content__sms__content`,
  SMS_TITLE: `${MAIN_CLASS}__content__sms__content__title`,
  SMS_BODY: `${MAIN_CLASS}__content__sms__content__body`,
  FOOTER: `${MAIN_CLASS}__footer`,
  BLUE_SPAN: `${MAIN_CLASS}__blue-span`,
};

interface SMSPhonePreviewProps {
  previewData: TSMSPreviewData;
  isLoading?: boolean;
}

function SMSPhonePreview({ previewData, isLoading }: SMSPhonePreviewProps) {
  return (
    <div className={MAIN_CLASS}>
      <div className={CLASSES.HEADER}>
        <PhoneNotch />
      </div>
      <div className={CLASSES.CONTENT}>
        <div className={CLASSES.SMS}>
          {isLoading ? (
            <Skeleton width="100%" height={125} />
          ) : (
            <>
              <div className={CLASSES.SMS_HEADER}>
                <div className={CLASSES.SMS_SENDER_NUMBER}>{previewData.data?.sender_number || 'Unknown Sender'}</div>
                <div className={CLASSES.SMS_TIME}>now</div>
              </div>
              <div className={CLASSES.SMS_CONTENT}>
                <div className={CLASSES.SMS_TITLE}>{previewData.title}</div>
                <div className={CLASSES.SMS_BODY}>
                  {(() => {
                    const segments = previewData.body.split(/({{.*?}})/g);
                    let offset = 0;
                    return segments.map((part) => {
                      const key = `${offset}-${part.length}`;
                      offset += part.length;
                      return /{{.*?}}/.test(part) ? (
                        <span key={key} title="Placeholder mapping needs to be corrected" className="error">
                          <span className="error__text">{part}</span>
                          <ErrorIcon className="error__icon" />
                        </span>
                      ) : (
                        <React.Fragment key={key}>{part}</React.Fragment>
                      );
                    });
                  })()}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      <div className={CLASSES.FOOTER} />
    </div>
  );
}

export default SMSPhonePreview;
